var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "dialog-overlay",
    on: {
      "click": _vm.handleOverlayClick
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: (_vm.containerStyle),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "dialog-header",
    style: ({
      paddingTop: _vm.titleTopSpacing + 'px'
    })
  }, [_c('h3', {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content",
    style: ({
      paddingLeft: _vm.contentHorizontalSpacing + 'px',
      paddingRight: _vm.contentHorizontalSpacing + 'px',
      paddingBottom: _vm.contentBottomSpacing + 'px'
    })
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.content))])], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    class: {
      'single-button': !_vm.showCancel
    }
  }, [(_vm.showCancel) ? _c('button', {
    staticClass: "dialog-btn btn-cancel",
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.cancelText) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "dialog-btn btn-confirm",
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.confirmText) + "\n\t\t\t\t\t")])])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-44fcc6b3","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmPopUp.vue
// module id = 241
// module chunks = 0